import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { ITeamDto } from "../../../Models/ITeamDto";
import i18n from "i18next";
import { ArrowExitFilled, ArrowExitRegular } from "@fluentui/react-icons";

interface ILeaveTeamDialog {
  onRemove(): void;
  selectedteam: ITeamDto;
}
function DialogLeaveTeam(props: ILeaveTeamDialog) {
  return (
    <Dialog>
      <DialogTrigger action="open">
        <Button appearance="transparent" icon={<ArrowExitFilled />}>
          {i18n.t<string>("leaveTeam")}
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("leaveTeam")}</DialogTitle>
          <DialogContent>{i18n.t<string>("leaveTeamText")}</DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => {
                props.onRemove();
              }}
            >
              {i18n.t<string>("leaveTeam")}
            </Button>
            <DialogTrigger action="close">
              <Button>{i18n.t<string>("cancel")}</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogLeaveTeam;
